export enum VehicularAssistanceRoutes {
    Base = "/asistencia-vehicular",
    StartRequest = "/asistencia-vehicular/inicio-solicitud",
    StartRequestBasicData = "/asistencia-vehicular/inicio-solicitud/datos-basicos",
    StartRequestGeolocation = "/asistencia-vehicular/inicio-solicitud/geolocalizacion",
    StartRequestCallCenterNotice = "/asistencia-vehicular/inicio-solicitud/aviso-call-center",
    StartRequestMepContinueNotice = "/asistencia-vehicular/inicio-solicitud/aviso-continua-mep",
    TireChange = "/asistencia-vehicular/inicio-solicitud/cambio-llanta",
    BatteryRecharge = "/asistencia-vehicular/inicio-solicitud/recarga-bateria",

    MepContinueNotice = "/asistencia-vehicular/continuar-mep-exito",
    CallCenterNotice = "/asistencia-vehicular/call-center-exito",
    AssistanceNoSuccess = "/asistencia-vehicular/asistencia-error",

    CraneRequest = "/asistencia-vehicular/solicitar-grua",
    CraneRequestSuccessBoardWorking = "/asistencia-vehicular/solicitar-grua/con-tablero/exito",
    CraneRequestSuccessBoardNoWorking = "/asistencia-vehicular/solicitar-grua/sin-tablero/exito",
    MechanicalSos = "/asistencia-vehicular/auxilio-mecanico",
    MechanicalSosSuccessBoardWorking = "/asistencia-vehicular/auxilio-mecanico/con-tablero/exito",
    MechanicalSosSuccessBoardNoWorking = "/asistencia-vehicular/auxilio-mecanico/sin-tablero/exito",
    DriverReplacement = "/asistencia-vehicular/chofer-de-reemplazo",
    DriverReplacementSuccess = "/asistencia-vehicular/chofer-de-reemplazo/exito",
}
